import { Quote } from "lucide-react";
import useScrollReveal from "../hooks/useScrollReveal";
import { useLanguage } from "../i18n/LanguageContext";

export default function Testimonials() {
  const [ref, isVisible] = useScrollReveal();
  const { lang, t } = useLanguage();
  const tm = t.testimonials;

  return (
    <section data-testid="testimonials-section" ref={ref} className="bg-[#0F1A2E] py-24 md:py-32 relative overflow-hidden">
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-[#D4AF37]/[0.025] rounded-full blur-[100px] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-16 transition-all duration-700" style={{ opacity: isVisible ? 1 : 0, transform: isVisible ? "translateY(0)" : "translateY(20px)" }}>
          <div className="flex items-center gap-3 mb-4">
            <div className="h-px w-12 bg-[#D4AF37]" />
            <span className="text-[#D4AF37] text-xs uppercase tracking-widest">{tm.label}</span>
          </div>
          <h2 className="text-4xl md:text-5xl text-white max-w-2xl leading-tight" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>{tm.heading}</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {tm.items.map((item, i) => (
            <div key={i} data-testid={`testimonial-${i}`}
              className="bg-[#162A45] border border-slate-800 p-8 hover:border-[#D4AF37]/30 transition-all duration-500 group relative flex flex-col"
              style={{ opacity: isVisible ? 1 : 0, transform: isVisible ? "translateY(0) scale(1)" : "translateY(28px) scale(0.96)", transition: "opacity 0.8s cubic-bezier(0.16,1,0.3,1), transform 0.8s cubic-bezier(0.16,1,0.3,1), border-color 0.5s", transitionDelay: `${i * 150}ms` }}>
              <div className="absolute top-0 left-0 h-px w-12 bg-[#D4AF37] group-hover:w-full transition-all duration-500" />
              <Quote size={28} className="text-[#D4AF37]/30 mb-5 flex-shrink-0" strokeWidth={1.5} />
              <p className="text-slate-300 text-sm leading-relaxed flex-1 italic mb-8">
                {lang === "fr" ? "\u00ab" : "\u201c"} {item.quote} {lang === "fr" ? "\u00bb" : "\u201d"}
              </p>
              <div className="border-t border-slate-800 pt-5">
                <p className="text-white text-sm font-medium">{item.author}</p>
                <p className="text-slate-300 text-xs mt-0.5">{item.company}</p>
                <span className="inline-block mt-3 text-[#D4AF37] text-[10px] uppercase tracking-widest border border-[#D4AF37]/20 px-2 py-0.5">{item.sector}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
